// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function FilePlus(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "FilePlus" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 21V3H14L19 7V21H5ZM11.2 17V13.8H8V12.2H11.2V9H12.8V12.2H16V13.8H12.8V17H11.2Z", fill: "currentColor" }))));
});
//# sourceMappingURL=FilePlus.js.map